import { useLoadableAction } from 'ocfe/src/utilHooks/useLoadableAction';
import { DataLoadable, isLoadSuccess, isLoading } from 'ocfe/src/utils/loadable';
import { useCallback, useContext } from 'react';
import OcApiRequest from 'src/Api/OcApiRequest';
import { TinyMCEConfig } from 'src/TinyMCE/TinyMCEConfig';
import { GlobalDataContext } from '../Global/GlobalData';

export const loadTinyMCEConfig = (): Promise<TinyMCEConfig> => {
    return OcApiRequest.get<TinyMCEConfig>('/shared/tinymce/globalconfig');
};

export const useTinyMCEConfig = (): readonly [DataLoadable<TinyMCEConfig>, () => void, string] => {
    const globalData = useContext(GlobalDataContext);
    const [tinyMCEConfigLoadable, doLoadTinyMCEConfig] = useLoadableAction(loadTinyMCEConfig);
    const load = useCallback(() => {
        if (!isLoadSuccess(tinyMCEConfigLoadable) && !isLoading(tinyMCEConfigLoadable)) {
            doLoadTinyMCEConfig();
        }
    }, [doLoadTinyMCEConfig, tinyMCEConfigLoadable]);
    return [tinyMCEConfigLoadable, load, globalData.communityKey] as const;
};
